/* eslint-disable */

import ApiClient from './ApiClient';
import {
  GetUserGoalProgress$Request,
  GetCompanySignUpCode$Request,
  GetGoalsWithProgress$Response,
  Logout$Response,
  LeaveGoal$Response,
  CreateGoal$Request,
  UploadAllAppleHealthActivities$Request,
  GetSpecificCompanyStatistics$Response,
  GetCompanyRankingFiltered$Request,
  DeleteGoal$Request,
  JoinCompany$Request,
  GetGoalGroupProgress$Request,
  GetLeaderboardGroups$Request,
  SaveGarminOauthRequestToken$Request,
  UpdateUserProfile$Response,
  JoinChat$Response,
  GetUserGoalProgress$Response,
  GetCompanyDivisions$Response,
  SignUp$Response,
  DeleteUserOwnedCompany$Response,
  ChangePassword$Response,
  SaveGarminOauthRequestToken$Response,
  GetChatUserToken$Response,
  SetUserThirdPartyIntegration$Response,
  UploadAllGoogleFitActivities$Response,
  CreateUserOwnedCompany$Request,
  SetUserThirdPartyIntegration$Request,
  DeleteUser$Response,
  BulkDeleteUsers$Request,
  BulkDeleteUsers$Response,
  UpdateProfileData$Request,
  GroupAssignment,
  GetLeaderboardGroups$Response,
  ChangePassword$Request,
  ToggleCompanyExcludedFromRanking$Response,
  UpdateActivityData$Response,
  JoinGoal$Request,
  GetLeaderboardPeople$Response,
  Login$Request,
  SetUserCountry$Request,
  CreateUser$Request,
  ChangeUserLanguage$Response,
  ChangeUserScreenOrientation$Request,
  ChangeUserScreenOrientation$Response,
  SignUp$Request,
  SetUserDivision$Response,
  UpdateProfileData$Response,
  DeleteGoal$Response,
  GetGoalCountryProgress$Response,
  ChangeUserLanguage$Request,
  CustomEntry$Request,
  GetGoalGroupProgress$Response,
  ExportGoalResults$Response,
  Login$Response,
  GetSpecificCompanyUsers$Response,
  SyncUserThirdPartyData$Response,
  CustomEntry$Response,
  FinalizeGarminIntegration$Response,
  UpdateGoal$Request,
  UploadAllGoogleFitActivities$Request,
  GetUserCompanyCountries$Response,
  GetCompanyCountries$Request,
  GetCompanyCountries$Response,
  GetCompanyRankingFiltered$Response,
  SetOnboardingStatusToActivityData$Response,
  GetUserDetailedProgress$Request,
  GoogleSignIn$Response,
  JoinCompany$Response,
  GetGoalCountryProgress$Request,
  GoogleSignIn$Request,
  SetUserCountry$Response,
  GetGoalIndividualProgress$Request,
  GetLeaderboardPeople$Request,
  GetUserDetailedProgress$Response,
  StartResetPassword$Response,
  LeaveGoal$Request,
  UpdateGoal$Response,
  LogString$Request,
  ToggleUserStatus$Response,
  LogString$Response,
  DeleteUserOwnedCompany$Request,
  CreateUserOwnedCompany$Response,
  UpdateUserProfile$Request,
  ToggleUserStatus$Request,
  ExportGoalResults$Request,
  DeleteUser$Request,
  ToggleCompanyExcludedFromRanking$Request,
  GetLeaderboardCountries$Response,
  CreateUser$Response,
  RegisterUser$Request,
  RegisterUser$Response,
  GetUserCustomProgress$Response,
  GetSpecificCompanyStatistics$Request,
  JoinGoal$Response,
  LeaveCompany$Request,
  JoinChat$Request,
  JoinGroupChat$Request,
  JoinGroupChat$Response,
  GetGroupMembers$Request,
  GetGroupMembers$Response,
  SetAppleHealthIntegration$Response,
  UploadAllAppleHealthActivities$Response,
  SetNoIntegration$Response,
  EndUserThirdPartyIntegration$Response,
  SetUserDivision$Request,
  DeleteActivity$Request,
  DeleteActivity$Response,
  GetActivityDuplicates$Request,
  GetActivityDuplicates$Response,
  GetActivityRoute$Request,
  GetActivityRoute$Response,
  SetMainActivity$Request,
  SetMainActivity$Response,
  FinalizeGarminIntegration$Request,
  StartResetPassword$Request,
  VerifyEmailCode$Request,
  VerifyEmailCode$Response,
  ResendEmailVerificationCode$Request,
  ResendEmailVerificationCode$Response,
  VerifyResetPasswordCode$Request,
  VerifyResetPasswordCode$Response,
  ResetPassword$Response,
  GetUserCustomProgress$Request,
  TogglePublicStatus$Response,
  GetCompanySignUpCode$Response,
  ResetPassword$Request,
  GetGoalIndividualProgress$Response,
  GetSpecificCompanyUsers$Request,
  GetLeaderboardCountries$Request,
  CreateGoal$Response,
  UpdateActivityData$Request,
  LeaveCompany$Response,
  GetAppleHealthSyncStart$Response,
  GetAppleHealthSyncTimes$Request,
  GetUserDailyDiaryProgress$Request,
  GetUserDailyDiaryProgress$Response,
  SetOnboardingStatusToIntegration$Response,
  GetCompanyStatisticsByPeriod$Request,
  GetCompanyStatisticsByPeriod$Response,
  GetCompanyEmployees$Request,
  GetCompanyEmployees$Response,
  SetCompanyEmployees$Request,
  SetCompanyEmployees$Response,
  GetGoogleFitAndroidSyncTimes$Request,
  GetWhoAmI$Request,
  GetWhoAmI$Response,
  GetChallengesWithProgress$Request,
  GetCompanyDetails$Request,
  GetCompanyDetails$Response,
  GetCompanyTeams$Request,
  GetCompanyTeams$Response,
  GetDivisions$Request,
  GetDivisions$Response,
  GetDivisionCategories$Request,
  GetDivisionCategories$Response,
  CreateDivisionCategory$Request,
  CreateDivisionCategory$Response,
  DeleteDivisionCategory$Request,
  DeleteDivisionCategory$Response,
  CreateTeam$Request,
  CreateTeam$Response,
  CreateDivision$Request,
  CreateDivision$Response,
  RenameTeam$Request,
  RenameTeam$Response,
  DeleteTeams$Request,
  DeleteTeams$Response,
  UpdateTeamSettings$Request,
  UpdateTeamSettings$Response,
  UpdateDivisionCategorySettings$Request,
  UpdateDivisionCategorySettings$Response,
  SetUserCategoryDivision$Request,
  SetUserCategoryDivision$Response,
  LockTeams$Request,
  LockTeams$Response,
  UnlockTeams$Request,
  UnlockTeams$Response,
  ExportChatMessages$Response,
  ExportChatMessages$Request,
  ExportChatImages$Response,
  ExportChatImages$Request,
  SetUserDevice$Request,
  SetUserDevice$Response,
  RemoveUserDevice$Request,
  RemoveUserDevice$Response,
  GetAnnouncements$Request,
  GetAnnouncements$Response,
  CreateAnnouncement$Request,
  CreateAnnouncement$Response,
  DeleteAnnouncements$Response,
  DeleteAnnouncements$Request,
  GetAnnouncementFilters$Request,
  GetAnnouncementFilters$Response,
  EditAnnouncement$Request,
  EditAnnouncement$Response,
  GetUserNotifications$Request,
  GetUserNotifications$Response,
  GetUserActivities$Request,
  GetUserActivities$Response,
  MarkUserNotificationRead$Request,
  MarkUserNotificationRead$Response,
  SaveImage$Response,
  SaveImage$Request,
  DeleteFile$Request,
  DeleteFile$Response,
  GetUserPreferences$Request,
  GetUserPreferences$Response,
  EditUserPreferences$Request,
  EditUserPreferences$Response,
  SetHealthConnectIntegration$Response,
  UploadAllHealthConnectActivities$Response,
  UploadAllHealthConnectActivities$Request,
  UploadActivity$Request,
  UploadActivity$Response,
  GetTotalPointsProgress$Request,
  GetTotalPointsProgress$Response, GetSingleChallengeWithProgress$Request, GetSingleChallengeWithProgress$Response,
  BulkAddAdminRole$Request,
  BulkAddAdminRole$Response,
  BulkRemoveAdminRole$Request,
  BulkRemoveAdminRole$Response,
  AssignTeamsRandomly$Request,
  GenerateTeams$Request,
  GenerateTeams$Response,
  GetAssignRandomTeamsFilters$Request,
  GetAssignRandomTeamsFilters$Response,
  CheckLoginMethod$Request,
  CheckLoginMethod$Response,
  ConfigureCompanySso$Request,
  ConfigureCompanySso$Response,
  GetCompanySsoConfigs$Request,
  GetCompanySsoConfigs$Response,
  GetCompanySsoConfig$Request,
  GetCompanySsoConfig$Response,
  CreateCompanySsoConfig$Request,
  CreateCompanySsoConfig$Response,
  UpdateCompanySsoConfig$Request,
  UpdateCompanySsoConfig$Response,
  DeleteCompanySsoConfig$Request,
  DeleteCompanySsoConfig$Response,
  EnableScim$Request,
  EnableScim$Response,
  DisableScim$Request,
  DisableScim$Response,
  RegenerateScimToken$Request,
  RegenerateScimToken$Response,
  GetCompanyDomains$Request,
  GetCompanyDomains$Response,
  AddCompanyDomain$Request,
  AddCompanyDomain$Response,
  RemoveCompanyDomain$Request,
  RemoveCompanyDomain$Response,
  VerifyCompanyDomain$Request,
  VerifyCompanyDomain$Response,
  GetCompanySignUpCodes$Request,
  GetCompanySignUpCodes$Response,
  CreateCompanySignUpCode$Request,
  CreateCompanySignUpCode$Response,
  UpdateCompanySignUpCode$Request,
  UpdateCompanySignUpCode$Response,
  DeleteCompanySignUpCode$Request,
  DeleteCompanySignUpCode$Response,
  GetCompanyInfo$Request,
  GetCompanyInfo$Response,
  UpdateCompanyInfo$Request,
  UpdateCompanyInfo$Response,
  GetCompanyFeatureFlags$Request,
  GetCompanyFeatureFlags$Response,
  UpdateCompanyFeatureFlags$Request,
  UpdateCompanyFeatureFlags$Response,
  SearchCompanies$Request,
  SearchCompanies$Response,
} from './api.types'
import { AxiosInstance, AxiosResponse } from 'axios';
import apiUrl from './apiUrl'

export class ApiService {

    public users: UsersApiService;
    public activity: ActivityApiService;
    public statistics: StatisticsApiService;
    public auth: AuthApiService;
    public notifications: NotificationsApiService;
    public upload: UploadApiService;

    constructor() {
        this.users = new UsersApiService(ApiClient);
        this.activity = new ActivityApiService(ApiClient);
        this.statistics = new StatisticsApiService(ApiClient);
        this.auth = new AuthApiService(ApiClient);
        this.notifications = new NotificationsApiService(ApiClient);
        this.upload = new UploadApiService(ApiClient);
    }

}

export class UsersApiService {
    constructor(private api: AxiosInstance) {}

    changeUserLanguage = async (request: ChangeUserLanguage$Request): Promise<AxiosResponse<ChangeUserLanguage$Response>> => {
        return this.api.post('changeUserLanguage', request);
    }
    changeUserScreenOrientation = async (request: ChangeUserScreenOrientation$Request): Promise<AxiosResponse<ChangeUserScreenOrientation$Response>> => {
        return this.api.post('changeUserScreenOrientation', request);
    }
    deleteUser = async (request: DeleteUser$Request): Promise<AxiosResponse<DeleteUser$Response>> => {
        return this.api.post('deleteUser', request);
    }
    bulkDeleteUsers = async (request: BulkDeleteUsers$Request): Promise<AxiosResponse<BulkDeleteUsers$Response>> => {
        return this.api.post('bulkDeleteUsers', request);
    }
    bulkAddAdminRole = async (request: BulkAddAdminRole$Request): Promise<AxiosResponse<BulkAddAdminRole$Response>> => {
        return this.api.post('bulkAddAdminRole', request);
    }
    bulkRemoveAdminRole = async (request: BulkRemoveAdminRole$Request): Promise<AxiosResponse<BulkRemoveAdminRole$Response>> => {
        return this.api.post('bulkRemoveAdminRole', request);
    }
    deleteUserOwnedCompany = async (request: DeleteUserOwnedCompany$Request): Promise<AxiosResponse<DeleteUserOwnedCompany$Response>> => {
        return this.api.post('deleteUserOwnedCompany', request);
    }
    getCompanyDivisions = async (): Promise<AxiosResponse<GetCompanyDivisions$Response>> => {
        return this.api.post('getCompanyDivisions');
    }
    getCompanySignUpCode = async (request: GetCompanySignUpCode$Request): Promise<AxiosResponse<GetCompanySignUpCode$Response>> => {
        return this.api.post('getCompanySignUpCode', request);
    }
    getCompanySignUpCodes = async (request: GetCompanySignUpCodes$Request): Promise<AxiosResponse<GetCompanySignUpCodes$Response>> => {
        return this.api.post('getCompanySignUpCodes', request);
    }
    createCompanySignUpCode = async (request: CreateCompanySignUpCode$Request): Promise<AxiosResponse<CreateCompanySignUpCode$Response>> => {
        return this.api.post('createCompanySignUpCode', request);
    }
    updateCompanySignUpCode = async (request: UpdateCompanySignUpCode$Request): Promise<AxiosResponse<UpdateCompanySignUpCode$Response>> => {
        return this.api.post('updateCompanySignUpCode', request);
    }
    deleteCompanySignUpCode = async (request: DeleteCompanySignUpCode$Request): Promise<AxiosResponse<DeleteCompanySignUpCode$Response>> => {
        return this.api.post('deleteCompanySignUpCode', request);
    }
    getCompanyEmployees = async (request: GetCompanyEmployees$Request): Promise<AxiosResponse<GetCompanyEmployees$Response>> => {
        return this.api.post('getCompanyEmployees', request);
    }
    setCompanyEmployees = async (request: SetCompanyEmployees$Request): Promise<AxiosResponse<SetCompanyEmployees$Response>> => {
        return this.api.post('setCompanyEmployees', request);
    }
    getSpecificCompanyUsers = async (request: GetSpecificCompanyUsers$Request): Promise<AxiosResponse<GetSpecificCompanyUsers$Response>> => {
        return this.api.post('getSpecificCompanyUsers', request);
    }
    getCompanyTeams = async (request: GetCompanyTeams$Request): Promise<AxiosResponse<GetCompanyTeams$Response>> => {
        return this.api.post('getCompanyTeams', request);
    }
    getDivisions = async (request: GetDivisions$Request): Promise<AxiosResponse<GetDivisions$Response>> => {
        return this.api.post('getDivisions', request);
    }
    getDivisionCategories = async (request: GetDivisionCategories$Request): Promise<AxiosResponse<GetDivisionCategories$Response>> => {
        return this.api.post('getDivisionCategories', request);
    }
    createDivisionCategory = async (request: CreateDivisionCategory$Request): Promise<AxiosResponse<CreateDivisionCategory$Response>> => {
        return this.api.post('createDivisionCategory', request);
    }
    deleteDivisionCategory = async (request: DeleteDivisionCategory$Request): Promise<AxiosResponse<DeleteDivisionCategory$Response>> => {
        return this.api.post('deleteDivisionCategory', request);
    }
    createTeam = async (request: CreateTeam$Request): Promise<AxiosResponse<CreateTeam$Response>> => {
        return this.api.post('createTeam', request);
    }
    createDivision = async (request: CreateDivision$Request): Promise<AxiosResponse<CreateDivision$Response>> => {
        return this.api.post('createDivision', request);
    }
    renameTeam = async (request: RenameTeam$Request): Promise<AxiosResponse<RenameTeam$Response>> => {
        return this.api.post('renameTeam', request);
    }
    deleteTeams = async (request: DeleteTeams$Request): Promise<AxiosResponse<DeleteTeams$Response>> => {
        return this.api.post('deleteTeams', request);
    }
    updateTeamSettings = async (request: UpdateTeamSettings$Request): Promise<AxiosResponse<UpdateTeamSettings$Response>> => {
        return this.api.post('updateTeamSettings', request);
    }
    updateDivisionCategorySettings = async (request: UpdateDivisionCategorySettings$Request): Promise<AxiosResponse<UpdateDivisionCategorySettings$Response>> => {
        return this.api.post('updateDivisionCategorySettings', request);
    }

    setUserCategoryDivision = async (request: SetUserCategoryDivision$Request): Promise<AxiosResponse<SetUserCategoryDivision$Response>> => {
        return this.api.post('setUserCategoryDivision', request);
    }
    lockTeams = async (request: LockTeams$Request): Promise<AxiosResponse<LockTeams$Response>> => {
        return this.api.post('lockTeams', request);
    }
    unlockTeams = async (request: UnlockTeams$Request): Promise<AxiosResponse<UnlockTeams$Response>> => {
        return this.api.post('unlockTeams', request);
    }
    getUserCompanyCountries = async (): Promise<AxiosResponse<GetUserCompanyCountries$Response>> => {
        return this.api.post('getUserCompanyCountries');
    }
    getCompanyCountries = async (request: GetCompanyCountries$Request): Promise<AxiosResponse<GetCompanyCountries$Response>> => {
        return this.api.post('getCompanyCountries', request);
    }
    leaveCompany = async (request: LeaveCompany$Request): Promise<AxiosResponse<LeaveCompany$Response>> => {
        return this.api.post('leaveCompany', request);
    }
    setUserCountry = async (request: SetUserCountry$Request): Promise<AxiosResponse<SetUserCountry$Response>> => {
        return this.api.post('setUserCountry', request);
    }
    setUserDivision = async (request: SetUserDivision$Request): Promise<AxiosResponse<SetUserDivision$Response>> => {
        return this.api.post('setUserDivision', request);
    }
    toggleCompanyExcludedFromRanking = async (request: ToggleCompanyExcludedFromRanking$Request): Promise<AxiosResponse<ToggleCompanyExcludedFromRanking$Response>> => {
        return this.api.post('toggleCompanyExcludedFromRanking', request);
    }
    togglePublicStatus = async (): Promise<AxiosResponse<TogglePublicStatus$Response>> => {
        return this.api.post('togglePublicStatus');
    }
    toggleUserStatus = async (request: ToggleUserStatus$Request): Promise<AxiosResponse<ToggleUserStatus$Response>> => {
        return this.api.post('toggleUserStatus', request);
    }
    setUserDevice = async (request: SetUserDevice$Request): Promise<AxiosResponse<SetUserDevice$Response>> => {
        return this.api.post('setUserDevice', request);
    }
    removeUserDevice = async (request: RemoveUserDevice$Request): Promise<AxiosResponse<RemoveUserDevice$Response>> => {
        return this.api.post('removeUserDevice', request);
    }
    getAnnouncements = async (request: GetAnnouncements$Request): Promise<AxiosResponse<GetAnnouncements$Response>> => {
        return this.api.post('getAnnouncements', request);
    }
    getAnnouncementFilters = async (request: GetAnnouncementFilters$Request): Promise<AxiosResponse<GetAnnouncementFilters$Response>> => {
        return this.api.post('getAnnouncementFilters', request);
    }
    createAnnouncement = async (request: CreateAnnouncement$Request): Promise<AxiosResponse<CreateAnnouncement$Response>> => {
        return this.api.post('createAnnouncement', request);
    }
    editAnnouncement = async (request: EditAnnouncement$Request): Promise<AxiosResponse<EditAnnouncement$Response>> => {
        return this.api.post('editAnnouncement', request);
    }
    deleteAnnouncements = async (request: DeleteAnnouncements$Request): Promise<AxiosResponse<DeleteAnnouncements$Response>> => {
        return this.api.post('deleteAnnouncements', request);
    }
    getUserNotifications = async (request: GetUserNotifications$Request): Promise<AxiosResponse<GetUserNotifications$Response>> => {
      return this.api.post('getUserNotifications', request);
    }
    getUserActivities = async (request: GetUserActivities$Request): Promise<AxiosResponse<GetUserActivities$Response>> => {
      return this.api.post('getUserActivities', request);
    }
    markUserNotificationRead = async (request: MarkUserNotificationRead$Request): Promise<AxiosResponse<MarkUserNotificationRead$Response>> => {
      return this.api.post('markUserNotificationRead', request);
    }
    assignTeamsRandomly = async (request: AssignTeamsRandomly$Request): Promise<AxiosResponse<any>> => {
        return this.api.post('assignTeamsRandomly', request);
    }
    generateTeams = async (request: GenerateTeams$Request): Promise<AxiosResponse<GenerateTeams$Response>> => {
        return this.api.post('generateTeams', request);
    }
    getAssignRandomTeamsFilters = async (request: GetAssignRandomTeamsFilters$Request): Promise<AxiosResponse<GetAssignRandomTeamsFilters$Response>> => {
        return this.api.post('getAssignRandomTeamsFilters', request);
    }
}

export class ActivityApiService {
    constructor(private api: AxiosInstance) {}

    createGoal = async (request: CreateGoal$Request): Promise<AxiosResponse<CreateGoal$Response>> => {
        return this.api.post('createGoal', request);
    }
    customEntry = async (request: CustomEntry$Request): Promise<AxiosResponse<CustomEntry$Response>> => {
        return this.api.post('customEntry', request);
    }
    deleteGoal = async (request: DeleteGoal$Request): Promise<AxiosResponse<DeleteGoal$Response>> => {
        return this.api.post('deleteGoal', request);
    }
    endUserThirdPartyIntegration = async (): Promise<AxiosResponse<EndUserThirdPartyIntegration$Response>> => {
        return this.api.post('endUserThirdPartyIntegration');
    }
    exportGoalResults = async (request: ExportGoalResults$Request): Promise<AxiosResponse<ExportGoalResults$Response>> => {
        return this.api.post('exportGoalResults', request);
    }
    exportChatMessages = async (request: ExportChatMessages$Request): Promise<AxiosResponse<ExportChatMessages$Response>> => {
        return this.api.post('exportChatMessages', request);
    }
    exportChatImages = async (request: ExportChatImages$Request): Promise<AxiosResponse<ExportChatImages$Response>> => {
        return this.api.post('exportChatImages', request);
    }
    finalizeGarminIntegration = async (request: FinalizeGarminIntegration$Request): Promise<AxiosResponse<FinalizeGarminIntegration$Response>> => {
        return this.api.post('finalizeGarminIntegration', request);
    }
    getAppleHealthSyncTimes = async (request: GetAppleHealthSyncTimes$Request): Promise<AxiosResponse<GetAppleHealthSyncStart$Response>> => {
        return this.api.post('getAppleHealthSyncTimes', request);
    }
    getHealthConnectSyncTimes = async (request: GetAppleHealthSyncTimes$Request): Promise<AxiosResponse<GetAppleHealthSyncStart$Response>> => {
        return this.api.post('getHealthConnectSyncTimes', request);
    }
    getGoogleFitAndroidSyncTimes = async (request: GetGoogleFitAndroidSyncTimes$Request): Promise<AxiosResponse<GetAppleHealthSyncStart$Response>> => {
        return this.api.post('getGoogleFitAndroidSyncTimes', request);
    }
    getChatUserToken = async (): Promise<AxiosResponse<GetChatUserToken$Response>> => {
        return this.api.post('getChatUserToken');
    }
    getCompanyRankingFiltered = async (request: GetCompanyRankingFiltered$Request): Promise<AxiosResponse<GetCompanyRankingFiltered$Response>> => {
        return this.api.post('getCompanyRankingFiltered', request);
    }
    getGoalCountryProgress = async (request: GetGoalCountryProgress$Request): Promise<AxiosResponse<GetGoalCountryProgress$Response>> => {
        return this.api.post('getGoalCountryProgress', request);
    }
    getGoalGroupProgress = async (request: GetGoalGroupProgress$Request): Promise<AxiosResponse<GetGoalGroupProgress$Response>> => {
        return this.api.post('getGoalGroupProgress', request);
    }
    getGoalIndividualProgress = async (request: GetGoalIndividualProgress$Request): Promise<AxiosResponse<GetGoalIndividualProgress$Response>> => {
        return this.api.post('getGoalIndividualProgress', request);
    }
    getSingleChallengeWithProgress = async (request: GetSingleChallengeWithProgress$Request): Promise<AxiosResponse<GetSingleChallengeWithProgress$Response>> => {
        return this.api.post('getSingleChallengeWithProgress', request);
    }
    getChallengesWithProgress = async (request: GetChallengesWithProgress$Request, config?: any): Promise<AxiosResponse<GetGoalsWithProgress$Response>> => {
        return this.api.post('getChallengesWithProgress', request, config);
    }
    getLeaderboardCountries = async (request: GetLeaderboardCountries$Request): Promise<AxiosResponse<GetLeaderboardCountries$Response>> => {
        return this.api.post('getLeaderboardCountries', request);
    }
    getLeaderboardGroups = async (request: GetLeaderboardGroups$Request): Promise<AxiosResponse<GetLeaderboardGroups$Response>> => {
        return this.api.post('getLeaderboardGroups', request);
    }
    getLeaderboardPeople = async (request: GetLeaderboardPeople$Request): Promise<AxiosResponse<GetLeaderboardPeople$Response>> => {
        return this.api.post('getLeaderboardPeople', request);
    }
    getSpecificCompanyStatistics = async (request: GetSpecificCompanyStatistics$Request): Promise<AxiosResponse<GetSpecificCompanyStatistics$Response>> => {
        return this.api.post('getSpecificCompanyStatistics', request);
    }
    getUserCustomProgress = async (request: GetUserCustomProgress$Request): Promise<AxiosResponse<GetUserCustomProgress$Response>> => {
        return this.api.post('getUserCustomProgress', request);
    }
    getTotalPointsProgress = async (request: GetTotalPointsProgress$Request): Promise<AxiosResponse<GetTotalPointsProgress$Response>> => {
        return this.api.post('getTotalPointsProgress', request);
    }
    getUserDailyDiaryProgress = async (request: GetUserDailyDiaryProgress$Request): Promise<AxiosResponse<GetUserDailyDiaryProgress$Response>> => {
        return this.api.post('getUserDailyDiaryProgress', request);
    }
    getUserDetailedProgress = async (request: GetUserDetailedProgress$Request): Promise<AxiosResponse<GetUserDetailedProgress$Response>> => {
        return this.api.post('getUserDetailedProgress', request);
    }
    getUserGoalProgress = async (request: GetUserGoalProgress$Request): Promise<AxiosResponse<GetUserGoalProgress$Response>> => {
        return this.api.post('getUserGoalProgress', request);
    }
    joinChat = async (request: JoinChat$Request): Promise<AxiosResponse<JoinChat$Response>> => {
        return this.api.post('joinChat', request);
    }
    joinGroupChat = async (request: JoinGroupChat$Request): Promise<AxiosResponse<JoinGroupChat$Response>> => {
        return this.api.post('joinGroupChat', request);
    }
    getGroupMembers = async (request: GetGroupMembers$Request): Promise<AxiosResponse<GetGroupMembers$Response>> => {
        return this.api.post('getGroupMembers', request);
    }
    joinCompany = async (request: JoinCompany$Request): Promise<AxiosResponse<JoinCompany$Response>> => {
        return this.api.post('joinCompany', request);
    }
    joinGoal = async (request: JoinGoal$Request): Promise<AxiosResponse<JoinGoal$Response>> => {
        return this.api.post('joinGoal', request);
    }
    leaveGoal = async (request: LeaveGoal$Request): Promise<AxiosResponse<LeaveGoal$Response>> => {
        return this.api.post('leaveGoal', request);
    }
    saveGarminOauthRequestToken = async (request: SaveGarminOauthRequestToken$Request): Promise<AxiosResponse<SaveGarminOauthRequestToken$Response>> => {
        return this.api.post('saveGarminOauthRequestToken', request);
    }
    setAppleHealthIntegration = async (): Promise<AxiosResponse<SetAppleHealthIntegration$Response>> => {
        return this.api.post('setAppleHealthIntegration');
    }
    setHealthConnectIntegration = async (): Promise<AxiosResponse<SetHealthConnectIntegration$Response>> => {
        return this.api.post('setHealthConnectIntegration');
    }
    setNoIntegration = async (): Promise<AxiosResponse<SetNoIntegration$Response>> => {
        return this.api.post('setNoIntegration');
    }
    setOnboardingStatusToActivityData = async (): Promise<AxiosResponse<SetOnboardingStatusToActivityData$Response>> => {
        return this.api.post('setOnboardingStatusToActivityData');
    }
    setOnboardingStatusToIntegration = async (): Promise<AxiosResponse<SetOnboardingStatusToIntegration$Response>> => {
        return this.api.post('setOnboardingStatusToIntegration');
    }
    setUserThirdPartyIntegration = async (request: SetUserThirdPartyIntegration$Request): Promise<AxiosResponse<SetUserThirdPartyIntegration$Response>> => {
        return this.api.post('setUserThirdPartyIntegration', request);
    }
    syncUserThirdPartyData = async (): Promise<AxiosResponse<SyncUserThirdPartyData$Response>> => {
        return this.api.post('syncUserThirdPartyData');
    }
    updateActivityData = async (request: UpdateActivityData$Request): Promise<AxiosResponse<UpdateActivityData$Response>> => {
        return this.api.post('updateActivityData', request);
    }
    updateGoal = async (request: UpdateGoal$Request): Promise<AxiosResponse<UpdateGoal$Response>> => {
        return this.api.post('updateGoal', request);
    }
    updateProfileData = async (request: UpdateProfileData$Request): Promise<AxiosResponse<UpdateProfileData$Response>> => {
        return this.api.post('updateProfileData', request);
    }
    updateUserProfile = async (request: UpdateUserProfile$Request): Promise<AxiosResponse<UpdateUserProfile$Response>> => {
        return this.api.post('updateUserProfile', request);
    }
    uploadAllAppleHealthActivities = async (request: UploadAllAppleHealthActivities$Request): Promise<AxiosResponse<UploadAllAppleHealthActivities$Response>> => {
        return this.api.post('uploadAllAppleHealthActivities', request);
    }
    uploadAllGoogleFitActivities = async (request: UploadAllGoogleFitActivities$Request): Promise<AxiosResponse<UploadAllGoogleFitActivities$Response>> => {
        return this.api.post('uploadAllGoogleFitActivities', request);
    }
      uploadAllHealthConnectActivities = async (request: UploadAllHealthConnectActivities$Request): Promise<AxiosResponse<UploadAllHealthConnectActivities$Response>> => {
    return this.api.post('uploadAllHealthConnectActivities', request);
  }

  /**
   * Upload a single activity to the backend
   * @param request - Activity data to upload
   * @returns Promise with upload result
   */
  uploadActivity = async (request: UploadActivity$Request): Promise<AxiosResponse<UploadActivity$Response>> => {
    return this.api.post('uploadActivity', request);
  }

  /**
   * Delete an activity from the backend
   * @param request - Activity ID to delete
   * @returns Promise with delete result
   */
  deleteActivity = async (request: DeleteActivity$Request): Promise<AxiosResponse<DeleteActivity$Response>> => {
    return this.api.post('deleteActivity', request);
  }

  /**
   * Fetch the full duplicate group for an activity (main + duplicates)
   * @param request - Any member activity ID of the group
   * @returns Promise with the group and the current main's ID
   */
  getActivityDuplicates = async (request: GetActivityDuplicates$Request): Promise<AxiosResponse<GetActivityDuplicates$Response>> => {
    return this.api.post('getActivityDuplicates', request);
  }

  /**
   * Fetch the GPS route points of a single activity (loaded on demand; list endpoints only set hasRoute)
   * @param request - The activity ID to fetch the route for
   * @returns Promise with the route points
   */
  getActivityRoute = async (request: GetActivityRoute$Request): Promise<AxiosResponse<GetActivityRoute$Response>> => {
    return this.api.post('getActivityRoute', request);
  }

  /**
   * Promote an activity to be the counted main of its duplicate group (locks the group)
   * @param request - The activity ID to set as main
   * @returns Promise with the refreshed group and the new main's ID
   */
  setMainActivity = async (request: SetMainActivity$Request): Promise<AxiosResponse<SetMainActivity$Response>> => {
    return this.api.post('setMainActivity', request);
  }


}

export class StatisticsApiService {
    constructor(private api: AxiosInstance) {}

    getCompanyStatisticsByPeriod = async (request: GetCompanyStatisticsByPeriod$Request): Promise<AxiosResponse<GetCompanyStatisticsByPeriod$Response>> => {
        return this.api.post('getCompanyStatisticsByPeriod', request);
    }

}

export class NotificationsApiService {
    constructor(private api: AxiosInstance) {}

    getUserPreferences = async (request: GetUserPreferences$Request): Promise<AxiosResponse<GetUserPreferences$Response>> => {
        return this.api.post('getUserPreferences', request);
    }

    editUserPreferences = async (request: EditUserPreferences$Request): Promise<AxiosResponse<EditUserPreferences$Response>> => {
        return this.api.post('editUserPreferences', request);
    }

}

export class AuthApiService {
    constructor(private api: AxiosInstance) {}

    changePassword = async (request: ChangePassword$Request): Promise<AxiosResponse<ChangePassword$Response>> => {
        return this.api.post('changePassword', request);
    }
    createUser = async (request: CreateUser$Request): Promise<AxiosResponse<CreateUser$Response>> => {
        return this.api.post('createUser', request);
    }
    createUserOwnedCompany = async (request: CreateUserOwnedCompany$Request): Promise<AxiosResponse<CreateUserOwnedCompany$Response>> => {
        return this.api.post('createUserOwnedCompany', request);
    }
    googleSignIn = async (request: GoogleSignIn$Request): Promise<AxiosResponse<GoogleSignIn$Response>> => {
        return this.api.post('googleSignIn', request);
    }
    logString = async (request: LogString$Request): Promise<AxiosResponse<LogString$Response>> => {
        return this.api.post('logString', request);
    }
    login = async (request: Login$Request): Promise<AxiosResponse<Login$Response>> => {
        return this.api.post('login', request);
    }
    logout = async (): Promise<AxiosResponse<Logout$Response>> => {
        return this.api.post('logout');
    }
    registerUser = async (request: RegisterUser$Request): Promise<AxiosResponse<RegisterUser$Response>> => {
        return this.api.post('registerUser', request);
    }
    resetPassword = async (request: ResetPassword$Request): Promise<AxiosResponse<ResetPassword$Response>> => {
        return this.api.post('resetPassword', request);
    }
    signUp = async (request: SignUp$Request): Promise<AxiosResponse<SignUp$Response>> => {
        return this.api.post('signUp', request);
    }
    startResetPassword = async (request: StartResetPassword$Request): Promise<AxiosResponse<StartResetPassword$Response>> => {
        return this.api.post('startResetPassword', request);
    }
    verifyEmailCode = async (request: VerifyEmailCode$Request): Promise<AxiosResponse<VerifyEmailCode$Response>> => {
        return this.api.post('verifyEmailCode', request);
    }
    resendEmailVerificationCode = async (request: ResendEmailVerificationCode$Request): Promise<AxiosResponse<ResendEmailVerificationCode$Response>> => {
        return this.api.post('resendEmailVerificationCode', request);
    }
    verifyResetPasswordCode = async (request: VerifyResetPasswordCode$Request): Promise<AxiosResponse<VerifyResetPasswordCode$Response>> => {
        return this.api.post('verifyResetPasswordCode', request);
    }
    getWhoAmI = async (request: GetWhoAmI$Request): Promise<AxiosResponse<GetWhoAmI$Response>> => {
        return this.api.post('getWhoAmI', request);
    }
    getCompanyDetails = async (request: GetCompanyDetails$Request): Promise<AxiosResponse<GetCompanyDetails$Response>> => {
        return this.api.post('getCompanyDetails', request);
    }

    // --- SSO methods ---

    // Email-first login lookup: determines if user should use password, SSO, or both
    checkLoginMethod = async (request: CheckLoginMethod$Request): Promise<AxiosResponse<CheckLoginMethod$Response>> => {
        return this.api.post('checkLoginMethod', request);
    }
    // @deprecated Use createCompanySsoConfig / updateCompanySsoConfig instead
    configureCompanySso = async (request: ConfigureCompanySso$Request): Promise<AxiosResponse<ConfigureCompanySso$Response>> => {
        return this.api.post('configureCompanySso', request);
    }
    // SSO Config: list all configs for a company
    getCompanySsoConfigs = async (request: GetCompanySsoConfigs$Request): Promise<AxiosResponse<GetCompanySsoConfigs$Response>> => {
        return this.api.post('getCompanySsoConfigs', request);
    }
    // SSO Config: get single config by ssoConfigId
    getCompanySsoConfig = async (request: GetCompanySsoConfig$Request): Promise<AxiosResponse<GetCompanySsoConfig$Response>> => {
        return this.api.post('getCompanySsoConfig', request);
    }
    // SSO Config: create new config (uses configureCompanySso with ssoConfigId=null)
    createCompanySsoConfig = async (request: CreateCompanySsoConfig$Request): Promise<AxiosResponse<CreateCompanySsoConfig$Response>> => {
        return this.api.post('configureCompanySso', request);
    }
    // SSO Config: update existing config (uses configureCompanySso with ssoConfigId set)
    updateCompanySsoConfig = async (request: UpdateCompanySsoConfig$Request): Promise<AxiosResponse<UpdateCompanySsoConfig$Response>> => {
        return this.api.post('configureCompanySso', request);
    }
    // SSO Config: delete config by ssoConfigId
    deleteCompanySsoConfig = async (request: DeleteCompanySsoConfig$Request): Promise<AxiosResponse<DeleteCompanySsoConfig$Response>> => {
        return this.api.post('deleteCompanySso', request);
    }
    // SCIM: enable SCIM provisioning for an SSO config
    enableScim = async (request: EnableScim$Request): Promise<AxiosResponse<EnableScim$Response>> => {
        return this.api.post('enableScim', request);
    }
    // SCIM: disable SCIM provisioning for an SSO config
    disableScim = async (request: DisableScim$Request): Promise<AxiosResponse<DisableScim$Response>> => {
        return this.api.post('disableScim', request);
    }
    // SCIM: regenerate bearer token for an SSO config
    regenerateScimToken = async (request: RegenerateScimToken$Request): Promise<AxiosResponse<RegenerateScimToken$Response>> => {
        return this.api.post('regenerateScimToken', request);
    }
    // SSO callback: exchange sessionId for a session (non-RPC endpoint)
    ssoCallback = async (request: { sessionId: string }): Promise<AxiosResponse<any>> => {
        return this.api.post('login', request, { baseURL: apiUrl('/auth/') });
    }

    // --- Domain verification methods ---

    // Admin: list verified/pending domains for a company
    getCompanyDomains = async (request: GetCompanyDomains$Request): Promise<AxiosResponse<GetCompanyDomains$Response>> => {
        return this.api.post('getCompanyDomains', request);
    }
    // Admin: add a new domain to a company
    addCompanyDomain = async (request: AddCompanyDomain$Request): Promise<AxiosResponse<AddCompanyDomain$Response>> => {
        return this.api.post('addCompanyDomain', request);
    }
    // Admin: remove a domain from a company
    removeCompanyDomain = async (request: RemoveCompanyDomain$Request): Promise<AxiosResponse<RemoveCompanyDomain$Response>> => {
        return this.api.post('removeCompanyDomain', request);
    }
    // Admin: trigger domain verification (manual or DNS)
    verifyCompanyDomain = async (request: VerifyCompanyDomain$Request): Promise<AxiosResponse<VerifyCompanyDomain$Response>> => {
        return this.api.post('verifyCompanyDomain', request);
    }

    // --- Company info methods ---

    // Admin: get company info for editing
    getCompanyInfo = async (request: GetCompanyInfo$Request): Promise<AxiosResponse<GetCompanyInfo$Response>> => {
        return this.api.post('getCompanyInfo', request);
    }
    // Admin: update company info
    updateCompanyInfo = async (request: UpdateCompanyInfo$Request): Promise<AxiosResponse<UpdateCompanyInfo$Response>> => {
        return this.api.post('updateCompanyInfo', request);
    }

    // Admin: get feature flags for a company
    getCompanyFeatureFlags = async (request: GetCompanyFeatureFlags$Request): Promise<AxiosResponse<GetCompanyFeatureFlags$Response>> => {
        return this.api.post('getCompanyFeatureFlags', request);
    }
    // Admin: update feature flags for a company
    updateCompanyFeatureFlags = async (request: UpdateCompanyFeatureFlags$Request): Promise<AxiosResponse<UpdateCompanyFeatureFlags$Response>> => {
        return this.api.post('updateCompanyFeatureFlags', request);
    }

    // Super Admin: search all companies
    searchCompanies = async (request: SearchCompanies$Request): Promise<AxiosResponse<SearchCompanies$Response>> => {
        return this.api.post('searchCompanies', request);
    }

}

export class UploadApiService {
    constructor(private api: AxiosInstance) {}

    uploadImage = async (request: SaveImage$Request): Promise<AxiosResponse<SaveImage$Response>> => {
        return this.api.post('uploadImage', request, {
          baseURL: apiUrl('/'),
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
    }

    deleteFile = async (request: DeleteFile$Request): Promise<AxiosResponse<DeleteFile$Response>> => {
      return this.api.post('deleteFile', request);
    }

}

const api = new ApiService();
export default api;
